module.exports = __webpack_public_path__ + "img/blue_bg.10fd2c51.png";